import { forwardRef, useState } from 'react';
import { cn } from '../../lib/cn';

export const Textarea = forwardRef(function Textarea(
  {
    className,
    style,
    invalid,
    rows = 5,
    maxLength,
    showCount = false,
    value,
    onFocus,
    onBlur,
    ...props
  },
  ref
) {
  const [focused, setFocused] = useState(false);
  const length = typeof value === 'string' ? value.length : 0;

  return (
    <div className="relative w-full">
      <textarea
        ref={ref}
        rows={rows}
        maxLength={maxLength}
        value={value}
        className={cn(
          'block w-full resize-y rounded-xl px-4 py-3 text-sm outline-none transition-all duration-200',
          'placeholder:text-[var(--dash-text-faint)]',
          className
        )}
        style={{
          background: 'var(--dash-surface-subtle)',
          color: 'var(--dash-text)',
          border: invalid
            ? '1px solid rgba(254,52,86,0.6)'
            : focused
              ? '1px solid var(--dash-primary)'
              : '1px solid var(--dash-border)',
          boxShadow: focused
            ? '0 0 0 4px rgba(173,52,254,0.12)'
            : invalid
              ? '0 0 0 4px rgba(254,52,86,0.08)'
              : 'none',
          fontFamily: 'inherit',
          ...style,
        }}
        onFocus={(e) => {
          setFocused(true);
          onFocus?.(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          onBlur?.(e);
        }}
        {...props}
      />
      {showCount && maxLength && (
        <span
          className="pointer-events-none absolute bottom-2.5 right-3 text-[10px] font-medium tabular-nums"
          style={{ color: 'var(--dash-text-faint)' }}
        >
          {length}/{maxLength}
        </span>
      )}
    </div>
  );
});
